import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './auth/Login';
import Signup from './auth/Signup';
import VerifyEmployee from './auth/VerifyEmployee';
import ForgetPassword from './auth/ForgetPassword';
import ResetPassword from './auth/ResetPassword';
import ClientManagment from './pages/Clients/ClientManagment';
import EmployeeDocuments from './pages/Clients/EmployeeDocuments';
import EmployeeBookkeeping from './pages/Clients/EmployeeBookkeeping';
import EmployeeProfile from './pages/Profile/EmployeeProfile';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify-employee" element={<VerifyEmployee />} />
        <Route path="/forgetpassword" element={<ForgetPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route path="/client" element={<ClientManagment />} />
            <Route path="/profile" element={<EmployeeProfile />} />
            <Route path="/employee-documents/:userId" element={<EmployeeDocuments />} />
            <Route path="/employee-bookkeeping/:userId" element={<EmployeeBookkeeping />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
